import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Asset, AssetTypeName } from '@app/_models/_DTOs/asset';
import { ITuple } from '@app/_models/tuple';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { NzDrawerRef, NzOptionComponent, UploadFile } from 'ng-zorro-antd';
import { AssetHistory, AssetHistoryActionName } from '@app/_models/_DTOs/assetHistory';
import { AssetHistoryActionType } from '@app/_models/assetHistoryActionType';
import { AssetViewModel } from '@app/_models/_viewModels/asset.viewmodel';
import { LocationService } from '@app/_services/location.service';
import { DepartmentService } from '@app/_services/department.service';
import { SupplierService } from '@app/_services/supplier.service';
import { EmployeeService } from '@app/_services/employee.service';
import { AssetGroup } from '@app/_models/_DTOs/assetGroup';
import { AssetGroupService } from '@app/_services/assetGroup.service';
import { Department } from '@app/_models/_DTOs/department';
import { Supplier } from '@app/_models/_DTOs/supplier';
import { Employee } from '@app/_models/_DTOs/employee';
import { AssetType } from '@app/_models/enums/assetType';
import { map } from 'rxjs/internal/operators/map';

import { NzMessageService } from 'ng-zorro-antd';
import { NgForm } from '@angular/forms';
import { HttpEventType } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Media } from '@app/_models/_DTOs/media';
import { Subject } from 'rxjs';
import { DocumentService } from '@app/_services/document.service';
import { Location } from '@app/_models/_DTOs/location';
import { AssetDetailsComponent } from '@app/assets/asset-details/asset-details.component';
import { ResizeService } from '@app/_services/resize.service';
import { SCREEN_SIZE } from '@app/_helpers/screen-size.enum';
import { AssetEditorComponent } from '@app/assets/asset-editor/asset-editor.component';
import { Sort } from '@app/_models/sort';
import { SortDirection } from '@app/_models/enums/sortDirection';
import { InventoryFoundAsset } from '@app/_models/_DTOs/inventoryFoundAsset';
import { InventoryFoundAssetService } from '@app/_services/inventoryFoundAsset.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Inventory } from '@app/_models/_DTOs/inventory';
import { InventoryService } from '@app/_services/inventory.service';
import { FoundAssetDetailsComponent } from '@app/found-asset-details/found-asset-details.component';

@Component({
  selector: 'app-found-assets',
  templateUrl: './found-assets.component.html',
  styleUrls: ['./found-assets.component.css']
})

export class FoundAssetsComponent implements OnInit {

  level: number = 0;

  sorts: Sort[] = [];
  pageIndex = 1;
  pageSize = 10;
  total = 1;
  assetList: InventoryFoundAsset[] = [];
  loading = true;

  locations: Location[] = [];
  // filteredLocations: Location[] = [];
  assetGroups: AssetGroup[] = [];
  departments: Department[] = [];
  suppliers: Supplier[] = [];
  employees: Employee[] = [];
  inventories: Inventory[] = [];

  @ViewChild(FoundAssetDetailsComponent, { static: false })
  private foundAssetDetailsComponent: FoundAssetDetailsComponent;

  selectedEmployee: Employee;

  selectedLocation: Location;

  nameSearchValue = "";
  inventoryCodeSearchValue = "";
  inventoryIdSearchValue: number[] = [];
  departmentIdSearchValue: number[] = [];
  employeeIdSearchValue: number[] = [];
  locationIdSearchValue: number[] = [];
  assetTypeSearchValue: number[] = [];
  assetGroupSearchValue: number[] = [];
  supplierIdSearchValue: number[] = [];

  public assetHistoryActionType = AssetHistoryActionType;
  public assetTypes = AssetType;

  apiUrl: string;

  screenSize: SCREEN_SIZE;

  public filterTimerStarted = false;
  public filterTimer;

  constructor(
    private foundAssetService: InventoryFoundAssetService,
    private breakpointObserver: BreakpointObserver,
    private locationService: LocationService,
    private departmentService: DepartmentService,
    private supplierService: SupplierService,
    private employeeService: EmployeeService,
    private assetGroupService: AssetGroupService,
    private inventoryService: InventoryService,
    private router: Router,
    private messageService: NzMessageService,
    private route: ActivatedRoute,
    private resizeService: ResizeService,
    private documentService: DocumentService
  ) {
    this.apiUrl = environment.apiUrl;
    this.resizeService.onResize$.subscribe(size => {
      this.screenSize = size;
    });
  }

  ngOnInit() {
    this.loadDataForDropdowns();

    this.route.queryParams.subscribe(params => {
      let inventoryId = params['inventoryId'];
      if (inventoryId != undefined) {
        this.inventoryIdSearchValue.push(inventoryId);
      }
    });
    this.searchData(true);
    if (this.resizeService.currentSize != null) {
      this.screenSize = this.resizeService.currentSize;
    }
  }

  loadDataForDropdowns() {
    this.departmentService.getAllBasic().subscribe((data: Department[]) => {
      this.departments = data;
    });
    this.employeeService.getAllBasic().subscribe((data: Employee[]) => {
      this.employees = data;
    });
    this.locationService.getAllBasic().subscribe((data: Location[]) => {
      this.locations = data;
    });
    this.assetGroupService.getAllBasic().subscribe((data: AssetGroup[]) => {
      this.assetGroups = data;
    });
    this.supplierService.getAllBasic().subscribe((data: Supplier[]) => {
      this.suppliers = data;
    });
    this.inventoryService.getAllBasic().subscribe((data: Inventory[]) => {
      this.inventories = data;
    });
  }

  sort(sort: { key: string; value: string }): void {
    var newSort: Sort = {
      PropertyName: sort.key,
      Direction: null
    };
    if (sort.value) {
      if (sort.value == "ascend") {
        newSort.Direction = SortDirection.Ascending;
      }
      else {
        newSort.Direction = SortDirection.Descending;
      }
    }

    if (newSort.Direction == null) {
      var existingSort = this.sorts.find(x => x.PropertyName == newSort.PropertyName);
      if (existingSort) {
        const index = this.sorts.indexOf(existingSort);
        if (index > -1) {
          this.sorts.splice(index, 1);
        }
      }
    }
    else {
      var existingSort = this.sorts.find(x => x.PropertyName == newSort.PropertyName);
      if (existingSort) {
        existingSort.Direction = newSort.Direction;
      }
      else {
        this.sorts.push(newSort);
      }
    }
    this.searchData();
  }

  getSortString() {
    var sortString = "";
    if (this.sorts && this.sorts.length > 0) {
      for (let sort of this.sorts) {
        if (sort.Direction == SortDirection.Ascending) {
          if (sortString.length == 0) {
            sortString = sort.PropertyName;
          }
          else {
            sortString += "," + sort.PropertyName;
          }
        }
        else {
          if (sortString.length == 0) {
            sortString = "-" + sort.PropertyName;
          }
          else {
            sortString += ",-" + sort.PropertyName;
          }
        }
      }
    }
    return sortString;
  }

  searchData(reset: boolean = false): void {
    if (reset) {
      this.pageIndex = 1;
    }
    var filters = "";
    if (this.nameSearchValue.length > 0) {
      filters += "Name@=" + this.nameSearchValue + ",";
    }
    if (this.inventoryCodeSearchValue.length > 0) {
      filters += "InventoryCode@=" + this.inventoryCodeSearchValue + ",";
    }
    if (this.departmentIdSearchValue.length > 0) {
      filters += "DepartmentId==" + this.departmentIdSearchValue.join("|") + ",";
    }
    if (this.employeeIdSearchValue.length > 0) {
      filters += "EmployeeId==" + this.employeeIdSearchValue.join("|") + ",";
    }
    if (this.locationIdSearchValue.length > 0) {
      filters += "LocationId==" + this.locationIdSearchValue.join("|") + ",";
    }
    if (this.assetTypeSearchValue.length > 0) {
      filters += "Type==" + this.assetTypeSearchValue.join("|") + ",";
    }
    if (this.assetGroupSearchValue.length > 0) {
      filters += "GroupId==" + this.assetGroupSearchValue.join("|") + ",";
    }
    if (this.supplierIdSearchValue.length > 0) {
      filters += "SupplierId==" + this.supplierIdSearchValue.join("|") + ",";
    }
    if (this.inventoryIdSearchValue.length > 0) {
      filters += "InventoryId==" + this.inventoryIdSearchValue.join("|") + ",";
    }

    var sortString = this.getSortString();
    if (sortString.length == 0) {
      sortString = "-Created"
    }
    else {
      sortString += ",-Created"
    }


    this.loading = true;
    this.foundAssetService
      .getPage(this.pageIndex, this.pageSize, sortString, filters)
      .subscribe((data: ITuple<InventoryFoundAsset>) => {
        this.loading = false;
        this.total = data.item2;
        this.assetList = data.item1;
      });
  }

  reset(): void {
    this.nameSearchValue = '';
    this.inventoryCodeSearchValue = '';
    this.departmentIdSearchValue = [];
    this.employeeIdSearchValue = [];
    this.locationIdSearchValue = [];
    this.assetTypeSearchValue = [];
    this.assetGroupSearchValue = [];
    this.supplierIdSearchValue = [];
    this.inventoryIdSearchValue = [];
    this.searchData(true);
  }

  deleteAsset(id: number) {
    this.foundAssetService.delete(id).subscribe(result => {
      this.messageService.create("success", "Inventurni višak uspješno obrisan");
      this.searchData();
    }, error => {
      console.log(error);
    });
  }

  openDetails(asset: Asset) {
    this.foundAssetDetailsComponent.loadAsset(asset.id);
  }

  closeDetails() {
    this.foundAssetDetailsComponent.selectedAsset = null;
    this.foundAssetDetailsComponent.isOpen = false;
  }

  openEmployeeDetails(employee: Employee) {
    this.employeeService
      .get(employee.id)
      .subscribe((data: Employee) => {
        this.selectedEmployee = data;
      });
  }

  openLocationDetails(location: Location) {
    this.locationService
      .get(location.id)
      .subscribe((data: Location) => {
        this.selectedLocation = data;
      })
  }

  closeEmployeeDetails() {
    this.selectedEmployee = null;
  }

  closeLocationDetails() {
    this.selectedLocation = null;
  }

  public getActionTypeName(actionType: AssetHistoryActionType) {
    return AssetHistoryActionName.get(actionType).name;
  }

  public getAssetTypeName(assetType: AssetType) {
    return AssetTypeName.get(assetType);
  }

  public assetTypeKeys() {
    var keys = Object.keys(this.assetTypes);
    return keys.slice(keys.length / 2);
  }

}
